import type { Signal } from '@crown/signal';

export const brandColors = [
  'primary',
  'secondary',
  'danger',
  'warning',
  'success',
  'info',
] as const;

export type BrandColor = (typeof brandColors)[number];

export type CleanupFn = () => void;

export type ActionHandler = (element: HTMLElement, event: Event) => void;

export type SignalOrRecord<T> = T extends boolean
  ? Signal.State<boolean>
  : T extends object
    ? { [K in keyof T]: Signal.State<T[K]> }
    : Signal.State<T>;

export interface HTMLSignalElement<SignalState> extends HTMLElement {
  signal?: SignalState extends Signal.State<infer State>
    ? Signal.State<State>
    : SignalOrRecord<SignalState>;
}
